import { Component } from "@angular/core";
import { IonicPage, NavController, NavParams } from "ionic-angular";
import { Api } from "../../services/api";
import { Http, Response } from "@angular/http";
import { Poster } from "../../services/poster";
import { ShareCard } from "../../services/sharecard";

@IonicPage({
  segment: "tybshare/:token",
})
@Component({
  selector: "page-tyb-share",
  templateUrl: "tyb-share.html",
})
export class TybSharePage {
  imageUrl = "";

  constructor(
    public navCtrl: NavController,
    private api: Api,
    private http: Http,
    public navParams: NavParams,
    private poster: Poster,
    private shareCard: ShareCard
  ) {}

  ionViewDidEnter() {
    document.title = "我邀您一起 在线学化学";

    const getPosterFileName = () => {
      return new Promise((resolve, reject) => {
        if (this.navParams.data.token.startsWith("___")) {
          const parsedData = JSON.parse(
            urlSafeBase64Decode(this.navParams.data.token.replace("___", ""))
          );
          this.api.getSharePoster(parsedData).then((data) => {
            this.imageUrl = this.poster.getUrl(data.fileName);
            resolve();
          });
        } else {
          this.http
            .get(
              `https://tianyuanbei.com:10003/api/wx-get-custom-poster-new?data=${this.navParams.data.token}`,
              {}
            )
            .subscribe(
              (res: Response) => {
                let body = res.json();
                this.imageUrl = `https://tianyuanbei.com:10003/posters/${body.fileName}`;
                resolve();
              },
              (error: Response | any) => {
                reject(error.json() || {});
              }
            );
        }
      });
    };

    getPosterFileName().then(() => {
      this.shareCard.share({
        title: "我邀您一起 在线学化学",
        desc:
          "天原杯化学学习网站，开设各种化学+竞赛+自招课程。新用户6折，快来看看吧！",
        link: location.href,
        imgUrl: this.imageUrl,
      });
    });
  }
}

function urlSafeBase64Decode(value) {
  return atob(
    value.split(".").join("=").split("-").join("/").split("_").join("+")
  );
}



// WEBPACK FOOTER //
// ./src/pages/tyb-share/tyb-share.ts